<template>
	<div class="storageoutprint" id="storageoutprint" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-form>
			<el-card>
				<el-row class="formTitle">
					<!-- <el-col :span="3">
						<label for>
							<el-checkbox v-model="is.weight" :true-label="1" :false-label="0" @change="ChangeWeightCkb"></el-checkbox>
							<span>称重</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.print" @change="ChangePrintCkb" :true-label="1" :false-label="0"></el-checkbox>
							<span>打单</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.pay" :true-label="1" :false-label="0"></el-checkbox>
							<span>收费</span>
						</label>
					</el-col> -->
					<el-col :span="5" style="color:transparent">1</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.logistic" :true-label="1" :false-label="0" @change="ChangeLogisticCkb"></el-checkbox>
							<span>生成物流</span>
						</label>
					</el-col>
				
					<!-- 					<el-col :span="3">
						<label>
							<el-checkbox v-model="is.photo" :true-label="1" :false-label="0"></el-checkbox>
							<span>拍照</span>
						</label>
					</el-col> -->
					<!-- <el-col :span="3">
						<label>
							<el-checkbox v-model="is.unpacking" :true-label="1" :false-label="0" @change="ChangePackCkb"></el-checkbox>
							<span>拆包扫描</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.checkcargo" :true-label="1" :false-label="0"></el-checkbox>
							<span>验商品</span>
						</label>
					</el-col> -->
					<!-- <el-col :span="3">
						<label for>
							<el-checkbox v-model="is.auto" :true-label="1" :false-label="0"></el-checkbox>
							<span>自动上架</span>
						</label>
					</el-col> -->
				</el-row>
				<el-row>
					<el-col :span="4" style="color:transparent">1</el-col>
					<el-col :span="14">
						<table style="width:99%">
							<tr>
								<td valign="top">
									<div class="formContent">
										<table class="htmltable" style="margin-left:70px">
											<tr class="b_font">
												<td class="tdleft">
													<span><b>批 次 号</b></span>
												</td>
												<td colspan="3">
													<el-input
														ref="handlebatch"
														@keyup.enter.native="EnterEvent('handlebatch')"
														@blur="updatebatch"
														v-model="form.handbatch"
													></el-input>
												</td>
											</tr>
											<tr class="b_font">
												<td class="tdleft">
													<span><b>货   架</b></span>
												</td>
												<td colspan="3">
													<el-select ref="shelves" filterable v-model="form.shelves" @keyup.enter.native="EnterEvent('shelves')" @change="GetOrderlist">
														<el-option v-for="(opt, opti) in shelveslist" :key="opti" :value="opt.d_name">{{ opt.d_name }}</el-option>
													</el-select>
												</td>
											</tr>
											<tr>
												<td class="tdleft_bold">
													<span>
														<b>单   号</b>
													</span>
												</td>
												<td colspan="3" class="b_font">
													<el-input
														ref="pkval"
														@keyup.enter.native="EnterEvent('pkval')"
														v-model="form.pkval"
													></el-input>
												</td>
											</tr>
											<tr v-if="is.logistic == 1">
												<td class="tdleft"><span>操作时间</span></td>
												<td colspan="3" style="text-align:left;">
													<el-date-picker v-model="form.wltime" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
												</td>
											</tr>
											<tr v-if="is.logistic == 1">
												<td class="tdleft"><span>操作描述</span></td>
												<td colspan="3"><el-input ref="wlcontent" v-model="form.wlcontent"></el-input></td>
											</tr>
										</table>
									</div>
								</td>
							</tr>
							<tr>
								<td style="width:50%;">
									<div class="b_font" style="font-size:25pt;color:#ab4a32;padding-left:80px">
										<span v-if="form.perpkval != ''"><b>上一单 : {{ form.perpkval }}</b></span>
									</div>
									<div class="formCargo">
										<i class="el-icon-d-arrow-right"></i>
										<label>
											已扫描
											<span class="ordercount">{{ scanordercount }}</span>
											单
										</label>
									</div>
									<tableui
										style="width:99%;"
										ref="storageinout"
										:tableData="orderTable"
										:columns="scanordercolumns"
										@gridhandle="gridhandle"
										:gridheight="orderheight"
									></tableui>
								</td>
							</tr>
						</table>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
import printhandler from '@/components/order/printhandler.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		printhandler
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			batch: '', //当前操作界面生成的临时批次号,可用于收费(暂时无用)
			fun: '上架',
			scanordercount: 0,
			errorcode: '', //错误码扫描
			errormsg: '',
			currentstate: '', //当前操作状态
			errorfocus: false,
			windowHeight: (window.innerHeight * 88) / 100,
			orderheight: (window.innerHeight * 35) / 100 + 'px',
			errorwin: false,
			orderTable: [],
			is: {
				logistic: 0 //生成物流
			},
			form: {
				pkval: '',
				handbatch: '',
				shelves: '', //操作货架
				perpkval: '',
				wlcontent: '',
				wltime: '',
				p_remark: '' ,//备注
				num:1
			},
			scanordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '100', sortable: false },
				{ field: 'shelves', title: '货架', type: 'text', width: '120', sortable: false },
				//{ field: 'remark', title: '详情', type: 'text', width: '150', sortable: false },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '80',
					sortable: false,
					template: [{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'removecheck' }]
				}
			],
			userid: localStorage.getItem('userid'),
			u_name: localStorage.getItem('u_name'),
			u_account: localStorage.getItem('u_account'),
			u_company: localStorage.getItem('u_company'),
			divclass: 'storageoutprint',
			
			wlset: {},
			shelveslist:[]//货架选项
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/wm/storageprint.scss');
		});
		this.LoadShelvesPage();
	},
	methods: {
		//获取勾选参数
		LoadShelvesPage() {
			var that = this;
			var paraminfo = {
				userid: localStorage.getItem('userid')
			};
			this.$apipost.get.LoadShelvesPage({ paraminfo: paraminfo }).then(res => {
				if (res != '') {
					that.is = res.userparam[0];
					that.form.handbatch = res.handbatch;
					if (res.wlset != undefined) {
						that.wlset = res.wlset;
						if (res.wlset.w_context != undefined) {
							that.form.wlcontent = res.wlset.w_context;
						}
					}
					this.$nextTick(function() {
						if (that.form.handbatch == '') that.$refs.handlebatch.focus();
						else {
							if (that.$refs.pkval.length > 0) that.$refs.pkval[0].focus();
							else that.$refs.pkval.focus();
						}
					});
					that.GetShelves();
				}
			});
		},	//获取货架
		async GetShelves() {
			var that = this;
			this.$apipost.get.dic({ type: '货架' }).then(res => {
				if (res != '') {
					that.shelveslist = res.data.list;
					if(that.shelveslist.length>0)
						that.form.shelves=that.shelveslist[0].d_name;
						that.GetOrderlist();
				}
			});
		},
		//列表操作栏事件
		gridhandle(e) {
			if (e.event == 'removecheck') {
				this.RollbackStorage(this.orderTable[e.index], parseInt(e.index));
			}
		},
		//文本框回调事件
		EnterEvent(control) {
			this.currentstate = control;
			if (control == 'pkval') {
				//获取订单信息
				this.form.pkval = this.form.pkval.trim();
				this.ScanPkVal(this.currentstate);
			}
			if (control == 'handlebatch') {
				if (this.$refs.shelves[0] != undefined) this.$refs.shelves[0].focus();
				else this.$refs.shelves.focus();
			}
			if (control == 'shelves') {
				if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
				else this.$refs.pkval.focus();
			}
		},
		//扫描单号触发事件
		ScanPkVal(type) {
			var isgo = true;
			if (this.form.handbatch == '') {
				this.$tool.message('请输入批次号', 2);
				this.ReadMsg('请输入批次号');
				isgo = false;
			}
			if (this.form.shelves == '') {
				this.$tool.message('请选择货架', 2);
				this.ReadMsg('请选择货架');
				isgo = false;
			}
			if (type == 'pkval') {
				if (this.form.pkval == '') isgo = false;
			}
			if (isgo) {
				this.SaveStorageShelves();
			} else {
				this.form.pkval = '';
			}
		},
		//保存上架记录
		SaveStorageShelves() {
			var that = this;
			var isgo = true;
			//这个判断是防止用户手动输入单号未回车，直接鼠标切换到其他输入框的情况
			if (that.form.pkval == '') {
				if (that.$refs.pkval[0] != undefined) that.$refs.pkval[0].focus();
				else that.$refs.pkval.focus();
					isgo = false;
			}
			if (isgo) {
				this.$tool.loading('正在操作', this.divclass);
				var paraminfo = {
					pageparam: this._data
				};
				//console.log('揽收参数',escape(JSON.stringify(paraminfo)));
				//return false;
				this.$apipost.post
					.SaveStorageShelves({
						paraminfo: paraminfo
					})
					.then(res => {
						this.$tool.loadingclose();
						if (res != '') {
							that.HandleInOut(res);
						} else {
							that.ReadMsg('系统异常，请重试');
						}
					});
			}
		},
		//生成物流
		CreateStep(){
			this.$apipost.post
				.CreateStep({
					pkval: this.form.pkval,
					batch:'',
					fun:this.fun,
					context:this.form.wlcontent,
					createtime:this.$tool.formatdate(this.form.wltime)
				})
				.then(res => {
					
				});
		},
		//处理出入库结果
		HandleInOut(res) {
			var that = this;
			if (res.state == '1') {
				this.ReadMsg('上架成功');
				if(this.is.logistic==1)
					that.CreateStep();
				//订单添加到已扫描表中
				that.addOrderList();
				//清空值，准备扫下一个单
				that.ClearInput();							
			} else {
				this.ReadMsg(res.message);
			}
		},
		//添加
		addOrderList() {
			var orderinfo = [];
			orderinfo = [{p_pkval: this.form.pkval,shelves:this.form.shelves}];
			this.form.perpkval=this.form.pkval;
			if (this.orderTable.length == 0) this.orderTable = orderinfo;
			else {
				this.orderTable.splice(0, 0, orderinfo[0]);
			}
		},
		//清空文本框
		ClearInput() {
			//debugger
			this.ScanSum();
			this.form.perpkval = this.form.pkval;
			this.form.pkval = '';
			this.form.p_remark = '';
			if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
			else this.$refs.pkval.focus();
		},
		ScanSum() {
			//计算汇总
			this.scanordercount = this.orderTable.length;
		},
		//回滚
		RollbackStorage(row, orderindex) {
			var that = this;
			var paraminfo = { row: row };
			this.$apipost.post
				.DelStorageShelves({
					paraminfo: paraminfo
				})
				.then(res => {
					if (res.state == 1) {
						this.$tool.message('删除成功', 1);
						that.orderTable.splice(orderindex, 1);
						//如果是子单，且是当前正在操作的子单，则添加回右边列表中
						that.ScanSum();
					} else {
						this.$tool.message('删除失败', 0);
					}
				});
		},
		ChangeLogisticCkb(value) {
			if (value) {
				this.form.wltime = this.$tool.formatdate();
				if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
				else this.$refs.pkval.focus();
			} else {
				this.form.wltime = '';
			}
		},
		//更新上架批次号
		updatebatch() {
			var newbatch = this.form.handbatch;
			if (newbatch != '') {
				var that = this;
				var paraminfo = { handbatch: this.form.handbatch, fun:this.fun, userid: localStorage.getItem('userid') };
				this.$apipost.post
					.UpdateOutBatch({
						paraminfo: paraminfo
					})
					.then(res => {
						that.GetOrderlist();
					});
			}
		},
		//根据批次号获取所有已扫描订单
		GetOrderlist() {
			var that = this;
			this.$apipost.get
				.GetShelveslistByBatch({
					handbatch: this.form.handbatch,
					shelves:this.form.shelves
				})
				.then(res => {
					that.orderTable = res.list;
					that.ScanSum();
				});
		},
		ReadMsg(msg) {
			if (this.$tool.checkprintcontrol()) {
				LODOP.FORMAT('VOICE:3;100', msg);
			}
		}
	}
};
</script>
